"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadowTransformer = exports.transitionTransformer = exports.getComponentStyle = void 0;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getComponentStyle = function getComponentStyle(path) {
  var transformFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
    return v;
  };
  return function (_ref) {
    var theme = _ref.theme,
        props = _objectWithoutProperties(_ref, ["theme"]);

    var interpolatedPath = path.replace(/\{(.*?)\}/g, function (_, val) {
      return props[val] || val;
    });
    var value = interpolatedPath.split('.').reduce(function (acc, key) {
      return acc && acc[key] || undefined;
    }, theme.componentStyles || {});

    if (typeof value === 'function') {
      return transformFn(value({
        theme: theme
      }));
    }

    return transformFn(value);
  };
};

exports.getComponentStyle = getComponentStyle;

var transitionTransformer = function transitionTransformer(transitions) {
  return transitions.map(function (param) {
    return param.join(' ');
  }).join(', ');
};

exports.transitionTransformer = transitionTransformer;

var shadowTransformer = function shadowTransformer(shadows) {
  return shadows.join(', ');
};

exports.shadowTransformer = shadowTransformer;